







import Vue from 'vue'
import { DayRangeElInterface } from '@/config/interfaces'
import Item2ColMultirowEl from '@/components/elements/Item2ColMultirowEl.vue'
import DayRangePickerEl from '@/components/elements/DayRangePickerEl.vue'

export default Vue.extend({
  name: 'DayRangeEl',

  components: {
    Item2ColMultirowEl,
    DayRangePickerEl
  },

  props: {
    templateItemData: {
      type: Object as () => DayRangeElInterface,
      required: true
    }
  }
})
